// SelectPackBox.js
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col, Button } from "react-bootstrap";
import "./SelectPackBox.css";
import { objectFiledDataStart } from "../../../redux/slice/objectSlice";
import { PackageSubSerivceList } from "../../../redux/slice/authSlice";
import { getData } from "../../../redux/slice/CalenderSlice";

export const SelectPackBox = ({selectedPackage, SelectPacknext, updateFieldData,bookingData }) => {
  const dispatch = useDispatch();
  const { instructorsdetails } = useSelector((state) => state?.instructors);
  const response =
    instructorsdetails && Array.isArray(instructorsdetails)
      ? instructorsdetails[0]?.data?.package
      : undefined;
  const [packageDetails, setPackageDetails] = useState([]);
  const [packSelect, setPackSelect] = useState(false);
  const [error, setError] = useState(false);
  const [selectedPackageIndex, setSelectedPackageIndex] = useState(-1);
  const {subServiceListData} = useSelector((state) => state?.auth);
  const [selectedDates, setSelectedDates] = useState([]);
  const [selectedStartDates, setSelectedStartDates] = useState(selectedPackage.start_date || []);
  const [selectedEndDates, setSelectedEndDates] = useState(selectedPackage.end_date || []);
  const { bookingDetail } = useSelector((state) => state?.auth);
  useEffect(() => {
    if (instructorsdetails) {
      setPackageDetails(response);
      
      if (bookingData?.package_id) {
        const selectedIndex = response?.findIndex(
          (item) => item.package_id === bookingData?.package_id
        );
        setSelectedPackageIndex(selectedIndex);
      }
    }
  }, [instructorsdetails, bookingData?.package_id]);

  


  const handleDateSelect = (time) => {
    const getDate = JSON.parse(localStorage.getItem("selectedDate"));
    const setCalendarTime = new Date(getDate);
    const formattedStartDateTime = formatDate(setCalendarTime);
  
    // Check for existing bookings
    const isBookingConflict = bookingDetail?.calendar_data?.some((e) => {
      return e?.start === formattedStartDateTime;
    });
  

    // Calculate end time
    const durationInMinutes = time;
    const endDateTime = new Date(setCalendarTime);
    endDateTime.setMinutes(endDateTime.getMinutes() + durationInMinutes);
    const formattedEndDateTime = formatDate(endDateTime);
    const currentDate = new Date();
  
    const newtime = setCalendarTime
      .toLocaleString("en-US", {
        hour: "numeric",
        minute: "numeric",
      })
      .toLocaleLowerCase();
  
    const newday = setCalendarTime.toLocaleDateString("locale", {
      weekday: "long",
    });
  
    const currDate = setCalendarTime.toLocaleDateString("en-US", {
      month: "long",
      day: "2-digit",
    });
  
    const endTime = setCalendarTime
      .toLocaleString("en-US", {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      })
      .toLocaleLowerCase();
  
    const cs = [{ newtime, newday, currDate }];
    dispatch(getData(cs));

  
    // Update all date arrays together
    setSelectedDates([...selectedDates, formattedStartDateTime]);
    setSelectedStartDates([...selectedStartDates, formattedStartDateTime]);
    setSelectedEndDates([...selectedEndDates, formattedEndDateTime]);
  
  };
  
  

  function formatDate(date) {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const seconds = date.getSeconds().toString().padStart(2, "0");

    const formattedTime = `${hours
      .toString()
      .padStart(2, "0")}:${minutes}:${seconds}`;

    return `${year}-${month}-${day} ${formattedTime}`;
  }

  useEffect(() => {
        updateFieldData("start_date", selectedStartDates);
        updateFieldData("end_date", selectedEndDates);
  }, [selectedDates]);

  const handleCheckboxChange = (event, packageId, amount, time, index,service_id,lesson_count) => {
    if (event.target.checked) {
      handleDateSelect(time);
      setSelectedPackageIndex(index);
      updateFieldData("package_id", packageId);
      updateFieldData("packageDuration", time);
      updateFieldData("amount", amount);
      updateFieldData("lesson_count",lesson_count)
      dispatch(PackageSubSerivceList({
        instructor_id:instructorsdetails[0]?.data?.id,
        service_id:service_id
      }));
      setError(false);
    } else {
      setSelectedPackageIndex(-1); 
    }
  };

  const SelectPackButtonHandler = () => {
    if (selectedPackageIndex !== -1) {
      SelectPacknext();
    } else {
      setError(true);
    }
  };
  return (
    <>
      <section className="select_box_container m-bot">
        <Container>
          <Row>
            <Col>
              <div className="d-flex justify-content-center ">
                <div className="select_box  br-10 mt-5">
                  <div className="select_box_head text-center ">
                    <p className="progress_head d-flex justify-content-center m-auto">Select Lesson or Pack</p>
                    {/* <p className="lesson_head_inner mt-3">
                      How many lessons do I need?
                    </p> */}
                  </div>
                  {packageDetails?.map((e, index) => {
                    return (
                      <div
                        className="select_box_middle d-flex justify-content-between m-4 mb-0 p-3"
                        key={index}
                      >
                        <div className="main_test_pack">
                          <p>
                            <input
                              id={index}
                              type="radio"
                              name="setpackage"
                              className="form-check-input"
                              onChange={(event) =>
                                {
                                  handleCheckboxChange(event, e.package_id, e.amount, e.time, index,e.service_id,e.lesson_count)
                                }
                              }
                              checked={index === selectedPackageIndex}
                            />
                            <label htmlFor={index}><span className="progress_sub_head">{e?.package_name},{e.lesson_count} Lessons</span></label>
                          </p>
                        </div>
                        <div className="progress_sub_head">
                          <p>${e?.amount}</p>
                        </div>
                      </div>
                    );
                  })}
                  <div className="alert_wrap">
                    {error && (
                      <span className="text-danger">
                        Select Lesson or Pack
                      </span>
                    )}
                  </div>
                  <div className="button_wrapper text-center">
                    <Button
                      variant="primary"
                      className="orange_btn text_manual br-10 select_lesson_btn ms-5 me-5 mb-2"
                      onClick={SelectPackButtonHandler}
                    >
                      Continue
                    </Button>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};
